<agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="zoom">
    <agm-marker [latitude]="latitude" [longitude]="longitude">
    </agm-marker>
    <agm-marker *ngFor="let long of coords" [latitude]="long.latitude1" [longitude]="long.longitude1">
        <agm-info-window [disableAutoPan]="true">
            <div [outerHTML]="contentString"></div>
        </agm-info-window>
    </agm-marker>
</agm-map>